import { getErrorCode } from "@/utils/errorHandlerUtils";

/**
 * Errores que no mejoran al repetir la petición: permisos (RLS), sesión
 * caducada, registro inexistente, datos inválidos o violación de restricción.
 * Reintentarlos solo alarga la espera antes de mostrar el estado de error.
 */
const NON_RETRYABLE_CODES = new Set([
  "42501", // permiso denegado (RLS)
  "PGRST116", // .single() sin fila
  "PGRST301", // JWT caducado / inválido
  "PGRST302",
  "22P02", // formato inválido
  "23502",
  "23503",
  "23505",
  "23514",
  "P0001", // RAISE EXCEPTION de nuestras funciones: mensaje para el usuario
]);

function statusOf(error: unknown): number | undefined {
  if (!error || typeof error !== "object") return undefined;
  const candidate = error as { status?: unknown; statusCode?: unknown };
  const value = candidate.status ?? candidate.statusCode;
  return typeof value === "number" ? value : undefined;
}

function isRetryableQueryError(error: unknown): boolean {
  const code = getErrorCode(error);
  if (code && NON_RETRYABLE_CODES.has(code)) return false;
  const status = statusOf(error);
  // 4xx es un fallo del lado cliente/permisos; 408 y 429 sí son transitorios.
  if (status && status >= 400 && status < 500 && status !== 408 && status !== 429) {
    return false;
  }
  return true;
}

/** Política global de reintentos: un reintento, solo para fallos transitorios. */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  return failureCount < 1 && isRetryableQueryError(error);
}
